import { Button } from '@components/atoms/Button/Button';
import { Meta } from '@components/atoms/MetaTags/Meta';
import { Title } from '@components/atoms/Title';
import { AboSelections } from '@components/molecules/AboSelections/AboSelections';
import { ReviewCard } from '@components/molecules/ReviewCard/ReviewCard';
import { DefaultOnlyLogo } from '@components/templates/layouts/DefaultOnlyLogo';
import type { Maybe, Meta as MetaType, Page, SubscriptionOverview } from '@src/lib/graphql/generated';
import { useActionLink } from '@utils/actionLink';
import { Image } from '@vgn-medien-holding/vgn-fe-components';
import Head from 'next/head';

export const SubscriptionOverviewPage = ({
  data,
}: {
  data: SubscriptionOverview & Page & { metadata?: Maybe<MetaType> | undefined };
}) => {
  const {
    feedback,
    feedback_headline,
    metadata,
    title,
    subheadline,
    offers,
    auto_balance,
    main_order_text,
    headline_offers_left,
    headline_offers_right,
    button_text,
    button_link,
    more,
  } = data;
  const buttonLink = useActionLink(button_link);

  return (
    <>
      <Head>{Meta(metadata)}</Head>
      <div className="absolute inset-x-0 top-0 h-screen w-full opacity-75">
        <Image copyright="" src="/assets/tvm_assets/bg-waves.png" alt="" fill imageMode="cover" />
        <div className="absolute bottom-0 left-0 h-1/2 w-full bg-gradient-to-t from-black" />
      </div>
      <div className="relative">
        <div className="mx-auto mb-8 max-w-4xl space-y-3 text-white lg:mb-12">
          <Title level={1} classProps={{ heading: 'heading-1 text-center font-herokid' }}>
            {title}
          </Title>
          <h2 className="mx-auto max-w-3xl text-center text-lg" dangerouslySetInnerHTML={{ __html: subheadline }}></h2>
        </div>
        {offers && (
          <AboSelections
            offers={offers}
            purchaseText={main_order_text}
            auto_balance={auto_balance}
            headlineLeft={headline_offers_left ?? ''}
            headlineRight={headline_offers_right ?? ''}
            more={more}
          />
        )}

        {/* {add_epaper && <EPaper data={[]} />} //TODO: Currently no data implementation */}

        <div className="mt-16 mb-20 flex flex-col items-center">
          <Title level={2} classProps={{ heading: 'text-heading-2 mb-8 font-herokid text-center' }}>
            {feedback_headline}
          </Title>
          <div className="scrollbar-hide relative w-full max-w-screen-2xl overflow-auto">
            <div className="grid w-full min-w-min grid-flow-col place-content-center gap-6">
              {feedback?.map((review, index) => (
                <ReviewCard
                  key={review.name ? review.name + index : index}
                  {...review}
                  classProps={{ root: 'min-w-64 xs:min-w-80 md:min-w-96' }}
                />
              ))}
            </div>
          </div>
          <Button
            title={button_text}
            link={buttonLink}
            hasAction={false}
            classProps={{ root: 'inline-block pointer-events-auto mt-8 mb-2' }}
            buttonStyle="primary"
          />
        </div>
      </div>
    </>
  );
};

SubscriptionOverviewPage.PageLayout = DefaultOnlyLogo;

export default SubscriptionOverviewPage;
